angular.
module("dx.webapp.exam").
constant("DX_SPELLCHECKSETTING", Object.freeze({
	SpellcheckSettingAllowOverride: 0,
	SpellcheckSettingAllowAll: 1,
	SpellcheckSettingDenyAll: 2,
}));
